module.exports = __webpack_public_path__ + "static/img/case_detail_16_1.10d99f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_16_1.png
// module id = DnNL
// module chunks = 34